
import echarts from 'echarts'

//折线图柱状图混合
function lineEchart({ idName, dataArray , xyAxisArray,_this}) {
    // 基于准备好的dom，初始化echarts实例

    console.log(dataArray)
    let myChart = echarts.init(document.getElementById(idName))

    // 指定图表的配置项和数据
    let option = {

        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#f5f5f5'
                }
            }
        },
        toolbox: {
            // feature: {
            //     dataView: {show: true, readOnly: false},
            //     magicType: {show: true, type: ['line', 'bar']},
            //     restore: {show: true},
            //     saveAsImage: {show: true}
            // }
        },
        // legend: {
        //     data:['蒸发量','平均温度']
        // },
        xAxis: [
            {
                type: 'category',
                data: dataArray,      //['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [
            {
                name: "项目数量",
                type: 'value',
                splitLine: {
                    lineStyle: {
                        type: 'dashed', //网格设置为虚线
                    }
                },
                min: 0,
                axisLabel: {
                    formatter: '{value}'
                },
                axisLine: {
                    lineStyle: {
                        color: "#268AA6"
                    }
                },
            },
            {
                name: "项目金额（万）",
                type: 'value',
                splitLine: {
                    lineStyle: {
                        type: 'dashed', //网格设置为虚线
                        color:"#f5f5f5"
                    }
                },
                min: 0,
                axisLabel: {
                    formatter: '{value}'
                },
                axisLine: {
                    lineStyle: {
                        color: "#F5A623"
                    }
                },
            }
        ],
        series: xyAxisArray
    }
   //图表右击事件
    if(_this){
      let tempData = {dataArray:dataArray,xyAxisArray:xyAxisArray};
      echartsRightMenu(idName,myChart,tempData,_this);
    }
   //图表右击事件end

    // 使用指定的配置项和数据显示图表。
    myChart.setOption(option);
}
//图表右键事件
/**
 * @param  domID 表id
 * @param  chart 表对象
 * @param  _this this对象
 */
function echartsRightMenu(domID,chart,data,_this){
  let parent = document.getElementById(domID);
      let offsetBody = getPoint(parent);
      parent .oncontextmenu = () => false;
      chart.off('contextmenu');
      chart.on('contextmenu', function (params) {//右键事件
          params.event.event.preventDefault();
          _this.$refs.echartsRightMenu.styleMenu = {"left":(offsetBody.left + params.event.offsetX+15)+"px","top":(offsetBody.top + params.event.offsetY+15)+"px"}
          _this.$refs.echartsRightMenu.show = true;
          _this.$refs.echartsRightMenu.domID = domID;
          _this.$refs.echartsRightMenu.excelData = data;
  });
}
//获取某元素以浏览器左上角为原点的坐标
function getPoint(obj) {
    var t = obj.offsetTop; //获取该元素对应父容器的上边距
    var l = obj.offsetLeft; //对应父容器的上边距
    //判断是否有父容器，如果存在则累加其边距
    while (obj = obj.offsetParent) {//等效 obj = obj.offsetParent;while (obj != undefined)
        t += obj.offsetTop; //叠加父容器的上边距
        l += obj.offsetLeft; //叠加父容器的左边距
    }
    return {top:t,left:l};
}
export  {
    lineEchart
}



// WEBPACK FOOTER //
// ./src/common/js/lineEchart.js